import styled, { css } from 'styled-components';
import { breakpoint } from '../theme/breakpoint';
import { linkOnDarkBgStyles } from '../styled/links';

export const Wrapper = styled.div`
  padding: 0;
  overflow: hidden;
  margin-bottom: ${({ $removeMarginBottom, theme }) =>
    $removeMarginBottom ? '0' : theme.spacing.large};
  background-color: ${({ $backgroundColor, theme }) =>
    ($backgroundColor === 'white' && theme.palette.white) ||
    ($backgroundColor === 'black' && theme.palette.darkBackground) ||
    ($backgroundColor === 'grey' && theme.palette.lightBackground) ||
    theme.palette.white};
`;

export const HeaderText = styled.h2`
  color: ${({ $backgroundColor, theme }) =>
    ($backgroundColor === 'black' && theme.palette.white) ||
    theme.palette.standardText};
`;

export const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;

export const ContentSemi = styled.div`
  & img {
    display: block;
    margin: 20px auto 0 auto;
  }

  & blockquote {
    & img {
      margin: 0 0 ${({ theme }) => theme.spacing.standard} 0;
    }
  }

  max-width: 100%;
  word-wrap: break-word;

  ${breakpoint.tablet`
    width:49%;
    word-wrap: normal;

    & img {
      margin: 0;
    }
  `};
`;

export const TextWrapper = styled.div`
  color: ${({ $backgroundColor, theme }) =>
    ($backgroundColor === 'black' && theme.palette.white) ||
    theme.palette.standardText};

  ${({ $backgroundColor }) =>
    $backgroundColor === 'black' &&
    css`
      a {
        ${linkOnDarkBgStyles}
      }
    `};

  > div {
    > h1,
    > h2,
    > h3,
    > h4 {
      & :first-child {
        margin-top: ${({ $backgroundColor }) =>
          $backgroundColor === 'white' && 0};
      }
    }
  }
`;
